module.exports = __webpack_public_path__ + "img/ms_BN.fc34ad24.png";